import { isEmpty } from './index'

export const required = value => {
  if (isEmpty(value)) {
    return 'This field is required'
  }

  return true
}

export const requiredNoTrimSpaces = value => {
  if (isEmpty(value)) {
    return 'This field is required'
  }

  if (typeof value === 'string' && /\s/.test(value)) {
    return 'Spaces are not allowed'
  }

  if (value.length < 5) {
    return 'Minimum 5 characters required'
  }

  if (value.length > 15) {
    return 'Maximum 15 characters allowed'
  }

  return true
}

export const shouldUnique = (value, compareValue) => {
  if (value === compareValue) {
    return 'Material name and code should not be same.'
  }

  return true
}

export const requiredWithName = (name, value) => {
  if (isEmpty(value)) {
    return `${name} field is required`
  }

  return true
}
export const emailValidator = value => {
  if (isEmpty(value)) {
    return true
  }

  // eslint-disable-next-line
  const re =
    /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/

  if (Array.isArray(value)) {
    return value.every(val => re.test(String(val)))
  }

  return re.test(String(value)) || 'The Email field must be a valid email'
}
export const emailValidatorRegister = value => {
  if (isEmpty(value)) return true

  const v = String(value).trim()
  // eslint-disable-next-line
  const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
  if (!re.test(v)) return 'The Email field must be a valid email'

  // block disposable/temporary domains
  const domain = v.split('@')[1]?.toLowerCase() || ''
  const DISPOSABLE = [
    /(^|\.)yopmail\.(com|fr|net)$/i,
    /(^|\.)mailinator\.(com|net|org)$/i,
    /(^|\.)10minutemail\.(com|net)$/i,
    /(^|\.)guerrillamail\.com$/i,
    /(^|\.)sharklasers\.com$/i,
    /(^|\.)getnada\.com$/i,
    /(^|\.)trashmail\.com$/i,
    /(^|\.)dispostable\.com$/i,
    /tempmail/i,
  ]
  if (DISPOSABLE.some(rx => rx.test(domain))) {
    return 'Test Emails are not allowed'
  }

  return true
}

export const passwordValidator = password => {
  /* eslint-disable no-useless-escape */
  const regExp = /(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[!@#$%&*()]).{8,}/
  /* eslint-enable no-useless-escape */
  const validPassword = regExp.test(password)

  return (
    // eslint-disable-next-line operator-linebreak
    validPassword ||
    'Field must contain at least one uppercase, lowercase, special character and digit with min 8 chars'
  )
}

export const phoneValidator = phone => {
  if (isEmpty(phone)) {
    return true
  }
  /* eslint-disable no-useless-escape */
  const regExp = /^\d{3}-\d{3}-\d{4}$/

  /* eslint-enable no-useless-escape */
  const validPassword = regExp.test(phone)

  return (
    // eslint-disable-next-line operator-linebreak
    validPassword || 'Format must be XXX-XXX-XXXX'
  )
}

export const confirmedValidator = (value, target) =>
  // eslint-disable-next-line implicit-arrow-linebreak
  value === target || 'The Confirm Password field confirmation does not match'

export const between = (value, min, max) => () => {
  const valueAsNumber = Number(value)

  return (
    (Number(min) <= valueAsNumber && Number(max) >= valueAsNumber) ||
    `Enter number between ${min} and ${max}`
  )
}

export const betweenValue = (value, min, max) => () => {
  if (isEmpty(value)) {
    return true
  }
  const valueAsNumber = Number(value)

  return (
    (Number(min) <= valueAsNumber && Number(max) >= valueAsNumber) ||
    `Enter number between ${min} and ${max}`
  )
}

export const integerValidator = value => {
  if (isEmpty(value)) {
    return true
  }

  if (Array.isArray(value)) {
    return value.every(val => /^-?[0-9]+$/.test(String(val)))
  }

  return /^-?[0-9]+$/.test(String(value)) || 'This field must be an integer'
}
export const nonNegetiveintegerValidator = value => {
  if (value === '' || value === null || value === undefined) {
    return 'This field is required'
  }
  const number = Number(value)

  if (isNaN(number)) {
    return 'Only numeric values are allowed'
  }

  if (number === 0) {
    return 'Zero is not allowed'
  }

  if (number < 0) {
    return 'Only positive numbers are allowed'
  }

  return true
}

export const regexValidator = (value, regex) => {
  if (isEmpty(value)) {
    return true
  }

  let regeX = regex
  if (typeof regeX === 'string') {
    regeX = new RegExp(regeX)
  }

  if (Array.isArray(value)) {
    return value.every(val => regexValidator(val, { regeX }))
  }

  return regeX.test(String(value)) || 'The Regex field format is invalid'
}

export const alphaValidator = value => {
  if (isEmpty(value)) {
    return true
  }

  // const valueAsString = String(value)

  return /^[A-Z]*$/i.test(String(value)) || 'The Alpha field may only contain alphabetic characters'
}

export const urlValidator = value => {
  if (value === undefined || value === null || value.length === 0) {
    return true
  }
  /* eslint-disable no-useless-escape */
  const re = /^((http|https):\/\/)(www\.){0,1}[a-zA-Z0-9\.\-]+\.[a-zA-Z]{2,5}[\.]{0,1}/

  return re.test(value) || 'URL is invalid'
}
export const urlValidatorRegister = value => {
  if (value == null || String(value).trim() === '') return true

  const v = String(value).trim()
  /* eslint-disable no-useless-escape */
  const regex = /^(https?:\/\/|www\.)[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}(\/.*)?$/

  return regex.test(v) || 'URL is invalid'
}

export const lengthValidator = (value, length = 10) => {
  if (isEmpty(value)) {
    return true
  }

  return value.length === length || `The number of Character must be ${length}`
}
export const minLengthValidator = (value, length) => {
  if (isEmpty(value)) {
    return true
  }

  return value.length >= length || `The Min number of Character  must be ${length}`
}
export const maxLengthValidator = (value, length) => {
  if (isEmpty(value)) {
    return true
  }

  return value.length <= length || `The Max number of Character  must be ${length}`
}
export const alphaDashValidator = value => {
  if (isEmpty(value)) {
    return true
  }

  const valueAsString = String(value)

  return /^[0-9A-Z_-]*$/i.test(valueAsString) || 'All Character is not valid'
}
export const minValue = (value, minVal = 1) => {
  if (isEmpty(value)) {
    return true
  }

  return value >= minVal || `The Value can't be less than ${minVal}`
}

export const minZero = (value, minVal = 0) => {
  if (isEmpty(value)) {
    return true
  }

  return value >= minVal || `The Value can't be less than ${minVal}`
}

export const minDecimalValue = (value, minVal = 0.001) => {
  if (isEmpty(value)) {
    return true
  }

  return value >= minVal || `The Value can't be less than ${minVal}`
}

export const decimalValidation = value => {
  if (isEmpty(value)) {
    return true
  }

  if (!/^-?\d+(\.\d{1,2})?$/.test(value)) {
    return 'Only two decimal places allowed'
  }

  return true
}

export const shouldSameValue = (value, compareValue, errorText) => {
  if (value !== compareValue) {
    return errorText
  }

  return true
}
export const validateStartDate = (v, endDate) => {
  if (endDate && new Date(v) > new Date(endDate)) {
    return 'Start Date must be before Need By Date'
  }

  return true
}

export const alphaNumericStartWithLetterValidator = value => {
  if (isEmpty(value)) {
    return true // Treat empty as valid (e.g., optional field)
  }

  const valueAsString = String(value)

  const pattern = /^(?!.*\s)(?!.*_$)[A-Za-z][A-Za-z0-9_]*$/

  return pattern.test(valueAsString) || 'Account must start with a letter and contain only alphanumeric characters & cannot end with underscore.'
}
